"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircularLoader = void 0;
var React = _interopRequireWildcard(require("react"));
var COLORS = _interopRequireWildcard(require("../../styles/variables/_color"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _CircularLoaderModule = _interopRequireDefault(require("./CircularLoader.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const CircularLoader = exports.CircularLoader = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    size = 'medium',
    className,
    colorToken = 'colorTextClickable',
    ariaLabel = 'Loading',
    testId
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'loader'
    }),
    className: (0, _classify.default)(_CircularLoaderModule.default.container, {
      [_CircularLoaderModule.default.mediumContainer]: size === 'medium',
      [_CircularLoaderModule.default.smallContainer]: size === 'small'
    }, className),
    ref: ref,
    "aria-label": ariaLabel,
    role: "alert",
    "aria-busy": "true",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: _CircularLoaderModule.default.spinLoader,
      "aria-hidden": "true",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _CircularLoaderModule.default.outerCircle,
        style: {
          '--color': COLORS[colorToken]
        }
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: _CircularLoaderModule.default.ellipse,
        style: {
          '--color': COLORS[colorToken]
        }
      })]
    })
  });
});